interface CoverCard {
    name?: string;
    title?: string;
    coverImage: {
        source: string;
        alt: string;
        footer?: string;
    };
}

interface CoverCards {
    [key: string]: CoverCard;
}

const coverCards: CoverCards = {
    aal: {
        name: "Arts and Law",
        coverImage: {
            source: "/case-studies/aal.jpg",
            alt: "College of Arts and Law",
        },
    },
    eps: {
        name: "Engineering and Physical Sciences",
        coverImage: {
            source: "/case-studies/eps.jpg",
            alt: "College of Engineering and Physical Sciences",
        },
    },
    mah: {
        name: "Medicine and Health",
        coverImage: {
            source: "/case-studies/mah.jpg",
            alt: "College of Medicine and Health",
        },
    },
    les: {
        name: "Life and Environmental Sciences",
        coverImage: {
            source: "/case-studies/les.jpg",
            alt: "College of Life and Environmental Sciences",
        },
    },
    coss: {
        name: "Social Sciences",
        coverImage: {
            source: "/case-studies/ss.jpg",
            alt: "College of Social Sciences",
        },
    },
    "press-release": {
        coverImage: {
            source: "/uob_crest.png",
            alt: "University of Birmingham Logo",
        },
    },
};

export default coverCards;
